<section class="mt-4 mb-5 document">
  <div class="container document-section-container">
    <div class="row" *ngIf="!documentItems?.length">
      <div class="col-md-12 head">
        <div class="mr-auto">
          <h4><img src="/assets/images/documents-icon.png" alt="Documents">Documents</h4>
          <h4>No Records Found.</h4>
        </div>
      </div>
    </div>

    <div *ngIf="documentItems?.length">
      <div class="row">
        <div class="col-md-12 head">
          <div class="mr-auto">
            <h4>
              <img src="/assets/images/documents-icon.png" alt="Documents">Documents
              <span>({{ documentItems.length }})</span>:
            </h4>
          </div>
          <div class="view-toggle-btns">
            <button type="button" class="view-toggle-btn" [class.view-toggle-active]="viewMode === 'grid'"
              (click)="setViewMode('grid')" title="Grid View">
              <i class="fa fa-th-large"></i>
            </button>
            <button type="button" class="view-toggle-btn" [class.view-toggle-active]="viewMode === 'list'"
              (click)="setViewMode('list')" title="List View">
              <i class="fa fa-list"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Grid View -->
      <div class="row" *ngIf="viewMode === 'grid'">
        <div class="col-12 col-md-6 col-lg-3 mt-4" *ngFor="let item of documentItems">
          <div class="box">
            <div class="srNo" style="cursor: pointer;" (click)="openDocumentItem(item)">{{ item.index }}</div>
            <strong>
              <h5 style="cursor: pointer;" (click)="openDocumentItem(item)">{{ item.title }}</h5>
            </strong>
            <div class="attach">
              <a href="javascript:void(0)" (click)="openDocumentItem(item)">
                <i class="fa" [ngClass]="item.isPdf ? 'fa-eye' : 'fa-download'" aria-hidden="true"></i>
                {{ item.isPdf ? 'View' : 'Download' }}
              </a>
            </div>

            <div class="doc-vote-card" *ngIf="item.minuteType && meetingIdForVote">
              <app-minute-vote-detail
                [meetingId]="meetingIdForVote"
                [minuteType]="item.minuteType"
                [allowVoting]="canVoteMinutes">
              </app-minute-vote-detail>
            </div>
          </div>
        </div>
      </div>

      <!-- List View (matches Agenda list design) -->
      <div class="ma-agenda-list-wrap mt-3" *ngIf="viewMode === 'list'">
        <ul class="ma-agenda-list">
          <li class="ma-agenda-list-li" *ngFor="let item of documentItems">
            <div class="ma-agenda-item-row">
              <button type="button" class="ma-agenda-item-btn" (click)="openDocumentItem(item)">
                <span class="ma-agenda-index-box">{{ item.index }}</span>
                <span class="ma-agenda-title">{{ item.title }}</span>
                <span class="ma-agenda-attach">
                  <i class="fa" [ngClass]="item.isPdf ? 'fa-eye' : 'fa-download'" aria-hidden="true"></i>
                  <span>{{ item.isPdf ? 'PDF' : (item.fileType || 'FILE') | uppercase }}</span>
                </span>
              </button>

              <div class="ma-agenda-vote-row" *ngIf="item.minuteType && meetingIdForVote">
                <app-minute-vote-detail
                  class="doc-list-minute-vote"
                  [meetingId]="meetingIdForVote"
                  [minuteType]="item.minuteType"
                  [allowVoting]="canVoteMinutes">
                </app-minute-vote-detail>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
